import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Globe, ArrowUpRight } from "lucide-react";
import { COMPANY, LOGO } from "@/lib/data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-primary text-primary-foreground relative overflow-hidden">
    <div className="grain absolute inset-0" />
    <div className="container-edge relative py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <img src={LOGO} alt="IPNOMICS" className="h-12 w-12 object-contain bg-white p-1" />
            <span className="font-display text-3xl">IPNOMICS LLP</span>
          </div>
          <p className="text-primary-foreground/70 max-w-md leading-relaxed">
            A premium intellectual property management &amp; consulting firm — protecting, safeguarding, and valuing the ideas that
            drive innovation forward.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-5 text-accent">Navigate</p>
          <ul className="space-y-3 text-primary-foreground/80">
            <li><Link data-testid="footer-link-knowledge" to="/knowledge" className="hover:text-accent transition-colors">Knowledge Bank</Link></li>
            <li><Link to="/#services" className="hover:text-accent transition-colors">Services</Link></li>
            <li><Link to="/#team" className="hover:text-accent transition-colors">Team</Link></li>
            <li><Link to="/contact" className="hover:text-accent transition-colors">Contact</Link></li>
            <li><Link data-testid="footer-admin-link" to="/admin/login" className="hover:text-accent transition-colors">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline mb-5 text-accent">Office</p>
          <ul className="space-y-4 text-primary-foreground/80">
            <li className="flex gap-3"><MapPin size={18} className="mt-1 shrink-0 text-accent" /><span>{COMPANY.address}, {COMPANY.region}</span></li>
            <li className="flex gap-3"><Mail size={18} className="mt-1 shrink-0 text-accent" /><a href={`mailto:${COMPANY.email}`} className="hover:text-accent transition-colors">{COMPANY.email}</a></li>
            <li className="flex gap-3"><Globe size={18} className="mt-1 shrink-0 text-accent" /><a href={`https://${COMPANY.website}`} target="_blank" rel="noreferrer" className="hover:text-accent transition-colors inline-flex items-center gap-1">{COMPANY.website} <ArrowUpRight size={14} /></a></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-primary-foreground/15 flex flex-col md:flex-row justify-between gap-4 text-sm text-primary-foreground/50">
        <span>© {new Date().getFullYear()} IPNOMICS LLP. All rights reserved.</span>
        <span>Securing Ideas. Empowering Innovation.</span>
      </div>
    </div>
  </footer>
);
